import React from 'react';
import classNames from 'classnames';
import addModifiers from 'utils/add_modifiers';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import envelopeSrc from 'images/envelope.svg';

class FeedbackContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackFormIsVisible: !this.props.prompt,
      feedbackSubmitted: false,
      feedback: '',
      error: false,
    };
    this.handleFeedbackChange = this.handleFeedbackChange.bind(this);
    this.submitFeedback = this.submitFeedback.bind(this);
    this.renderFeedbackForm = this.renderFeedbackForm.bind(this);
    this.renderFormSuccessNotification =
      this.renderFormSuccessNotification.bind(this);
    this.toggleFeedbackForm = this.toggleFeedbackForm.bind(this);
  }

  handleFeedbackChange(e) {
    this.setState({ feedback: e.target.value });
  }

  submitFeedback() {
    request
      .post(routes.VIDEO_RESPONSE_TECHNICAL_ISSUES(this.props.questionId), {
        message: this.state.feedback,
        assignor_id: this.props.assignorId,
      })
      .then(payload => {
        if (payload.success) {
          this.setState({ feedbackSubmitted: true, error: false });
        } else {
          this.setState({ error: true });
        }
      })
      .fail(this.setState({ error: true }));
  }

  toggleFeedbackForm() {
    this.setState(state => ({
      feedbackFormIsVisible: !state.feedbackFormIsVisible,
      feedback: '',
      feedbackSubmitted: false,
      error: false,
    }));
  }

  renderFeedbackForm() {
    const { title, placeholder, buttonText, error, fullWidth, cancel } =
      this.props;
    const buttonStyles = classNames(
      `${addModifiers('CustomColor', [
        'backgroundColor',
        'buttonBoxShadow',
      ])} ${addModifiers('NewButton', [
        'tallAndWide',
        'lessonlyBrandColor',
        'center',
      ])}`,
      {
        'NewButton--fw': !prompt || !fullWidth,
      },
    );
    const buttonContainerStyles = classNames({
      'd-f ai-c': prompt && fullWidth,
      'jc-e': !this.state.error,
      'jc-sb': this.state.error,
    });

    return (
      <div className="Animated Animated--popDown">
        <div className="FeedbackForm-title fz-bigger">{title}</div>
        <div className="FeedbackForm-form">
          <textarea
            className="FeedbackForm-feedback w-fill"
            onChange={this.handleFeedbackChange}
            placeholder={placeholder}
            value={this.state.feedback}
          />
          <div className={buttonContainerStyles}>
            {this.state.error && <div className="c-brand-red">{error}</div>}
            <div>
              {prompt && fullWidth && (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <span
                  className="FeedbackForm-cancel c-p mr-16"
                  onClick={() => this.toggleFeedbackForm()}
                >
                  {cancel}
                </span>
              )}
              <button
                type="button"
                className={buttonStyles}
                onClick={() => this.submitFeedback()}
                disabled={this.state.feedback.trim().length === 0}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFormSuccessNotification() {
    return (
      <div className="d-f fd-c">
        <img
          className="FeedbackForm-successHeader"
          src={envelopeSrc}
          alt={this.props.successText.thanks}
        />
        <div className="FeedbackForm-successBody lh-24">
          <div className="fw-b">{this.props.successText.thanks}</div>
          <div>{this.props.successText.followUp}</div>
          <button
            type="button"
            onClick={() => this.toggleFeedbackForm()}
            className="NewButton NewButton--white mt-24"
          >
            {this.props.dismiss}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { fullWidth, prompt } = this.props;
    const { feedbackFormIsVisible, feedbackSubmitted } = this.state;
    const formClasses = classNames('FeedbackForm', {
      'FeedbackForm--submitted':
        this.state.feedbackSubmitted && !this.state.error,
      'FeedbackForm--fullWidth': fullWidth,
      'pos-a': !fullWidth,
    });
    const promptClasses = classNames('pos-r', {
      'mb-8': feedbackFormIsVisible,
    });
    const callToActionClasses = classNames('ml-4', {
      'c-p VideoResponseQuestion-reportTechnicalDifficulties':
        !feedbackFormIsVisible,
    });

    return (
      <div className="fz-bigger pos-r">
        {prompt && (
          <div className={promptClasses}>
            <span>{prompt.question}</span>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <span
              className={callToActionClasses}
              onClick={
                !feedbackFormIsVisible ? () => this.toggleFeedbackForm() : null
              }
            >
              {prompt.callToAction}
            </span>
          </div>
        )}
        {feedbackFormIsVisible && (
          <div className={formClasses}>
            {feedbackSubmitted &&
              !this.state.error &&
              this.renderFormSuccessNotification()}
            {!feedbackSubmitted && this.renderFeedbackForm()}
          </div>
        )}
      </div>
    );
  }
}

export default FeedbackContainer;
